module.exports = __webpack_public_path__ + "static/media/jxzy.c6ac9daf.mp4";